export default "__VITE_ASSET__b90a698a__"